import { Directive, ElementRef, Input, NgModule, OnChanges, SimpleChanges, inject, SecurityContext } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {DomSanitizer} from '@angular/platform-browser';

declare let $: any;

@Directive({
    selector: '[spinEl]',
    standalone: false
})
export class SpinElDirective implements OnChanges {

    @Input() spinning: boolean;
    @Input() disabled: boolean;
    @Input() spinText: string = 'Submitting...';
    @Input() innerText: string = '';
    sanitizer: DomSanitizer;
    constructor(private el: ElementRef,
                protected translateSvc: TranslateService
    ) {
        this.sanitizer = inject(DomSanitizer);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const $buttonEl = $(this.el.nativeElement);
        if(changes['spinning']) {

            const spinning = changes['spinning'].currentValue === true;

            if(spinning) {
                $buttonEl.attr('data-spinning', 'true');
                const content = $buttonEl.html().trim();
                let textEl = this.spinText.length > 0 ? `<span class="mx-3 spin-text" translate>`+this.translateSvc.instant(this.spinText)+`</span>` : '';
                $buttonEl.attr('data-spin-content', content);
                $buttonEl.html(`<div class="d-flex align-items-center justify-content-center spin-container" aria-live="polite" role="progressbar">
                                    <i class="fa-spin material-icons" style="opacity:0;">donut_large</i>`
                                    +textEl+
                                `</div>`);
                $buttonEl.attr('disabled', true);
                setTimeout(function() {
                    $('.material-icons').css('opacity',1);
                }, 100);
            } else if ($buttonEl.data('spinning') == true) {
                const content = $buttonEl.data('spin-content');
                if(content) $buttonEl.html(content);
                if (this.innerText) $buttonEl.html( this.innerText);
                $buttonEl.removeAttr('data-spinning');
                $buttonEl.removeAttr('data-spin-content');
                $buttonEl.removeAttr('disabled');
            }
        }
        if(changes['disabled']) {
            if (changes['disabled'].currentValue === true) {
                $buttonEl.attr('disabled', true);
            } else {
                $buttonEl.removeAttr('disabled');
            }
        }
    }

}

@NgModule({
    declarations: [SpinElDirective],
    exports: [SpinElDirective]
})
export class SpinElDirectiveModule {}
